import { render } from "./MarqueeLogos.vue?vue&type=template&id=3be67908"
import script from "./MarqueeLogos.vue?vue&type=script&lang=js"
export * from "./MarqueeLogos.vue?vue&type=script&lang=js"

import "./MarqueeLogos.vue?vue&type=style&index=0&id=3be67908&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__